// src/index.ts
import {
  UniPassProvider
} from "@unipasswallet/ethereum-provider";
import { providers } from "ethers";
import { Connector } from "wagmi";
import {
  UserRejectedRequestError,
  createWalletClient,
  custom
} from "viem";
var UniPassConnector = class extends Connector {
  id = "unipass";
  name = "UniPass";
  ready = true;
  options;
  provider;
  constructor({ chains, options }) {
    super({ chains, options });
    this.options = options;
    this.provider = new UniPassProvider(options);
  }
  get upAccount() {
    return this.getUpAccount();
  }
  async connect() {
    let _account;
    try {
      this?.emit("message", { type: "connecting" });
      _account = await this.provider.connect();
    } catch (error) {
      if (/user rejected/i.test(error?.message)) {
        throw new UserRejectedRequestError(error);
      }
      throw error;
    }
    const chianId = this.provider.getChainId();
    const address = _account.address;
    return {
      account: address,
      chain: {
        id: chianId,
        unsupported: false
      },
      provider: new providers.Web3Provider(this.provider, "any")
    };
  }
  async disconnect() {
    await this.provider.disconnect();
  }
  async getWalletClient() {
    const [provider, account] = await Promise.all([
      this.getProvider(),
      this.getAccount()
    ]);
    const chainId = await this.getChainId();
    const chain = this.chains.find((x) => x.id === chainId);
    if (!provider || !account)
      throw new Error("provider is required.");
    return createWalletClient({
      account,
      chain,
      transport: custom(provider)
    });
  }
  async getAccount() {
    return Promise.resolve(this.upAccount?.address || "");
  }
  async getChainId() {
    return Promise.resolve(this.provider.getChainId());
  }
  async getProvider() {
    return Promise.resolve(this.provider);
  }
  async getSigner() {
    const chainId = await this.getChainId();
    const account = await this.getAccount();
    return Promise.resolve(
      new providers.Web3Provider(this.provider, chainId).getSigner(account)
    );
  }
  async switchChain(chainId) {
    await this.provider?.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: `0x${chainId.toString(16)}` }]
    });
    this?.emit("change", { chain: { id: chainId, unsupported: false } });
    return { id: chainId };
  }
  async isAuthorized() {
    return Promise.resolve(!!sessionStorage.getItem("UP-A"));
  }
  onAccountsChanged(accounts) {
    return { account: accounts[0] };
  }
  onChainChanged(chain) {
    this.provider?.events?.emit("chainChanged", chain);
    this?.emit("change", { chain: { id: chain, unsupported: true } });
  }
  onDisconnect() {
    this?.emit("disconnect");
  }
  getUpAccount() {
    try {
      const sessionAccount = sessionStorage.getItem("UP-A");
      const localAccount = localStorage.getItem("UP-A");
      if (sessionAccount)
        return JSON.parse(sessionAccount);
      if (localAccount)
        return JSON.parse(localAccount);
    } catch {
      return;
    }
    return;
  }
};
export {
  UniPassConnector
};
